import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const ARTICLES = [
  {
    num: "01",
    title: "Votre réservation",
    points: [
      "Pour être sûr d'avoir votre table, nous vous conseillons vivement de réserver en ligne.",
      "En cas de retard, la fin de la session reste inchangée pour respecter les créneaux suivants. Si le retard est trop important, nous pourrons malheureusement annuler votre créneau.",
      "Un créneau ne peut pas être avancé : entre deux sessions, il faut nettoyer, préparer les tables et boucler la caisse.",
      "Par respect pour tous les participants, chaque session s'achève à l'heure prévue.",
    ],
  },
  {
    num: "02",
    title: "Les jeunes créateurs",
    points: [
      "Les moins de 16 ans sont les bienvenus, accompagnés d'au moins un adulte pendant tout l'atelier.",
      "L'adulte accompagnant garde la responsabilité de l'enfant du début à la fin de la session.",
    ],
  },
  {
    num: "03",
    title: "Tarifs & règlement",
    points: [
      "Chaque pièce affiche son prix, tout compris : matériel, peintures, conseils, émaillage et cuisson.",
      "Toute place réservée ou occupée compte comme une participation à l'atelier.",
      "Le règlement se fait simplement sur place, le jour de l'atelier.",
    ],
  },
  {
    num: "04",
    title: "La vie de l'atelier",
    points: [
      "Prenez soin du matériel et des espaces comme s'ils étaient les vôtres : toute dégradation volontaire pourra être facturée.",
      "Venez avec une tenue qui ne craint rien : l'atelier décline toute responsabilité en cas de tache ou de détérioration de vos effets personnels.",
      "Vos affaires restent sous votre responsabilité : l'atelier ne pourra être tenu responsable en cas de perte ou d'oubli.",
      "Nous nous réservons le droit de refuser l'accès ou d'écourter une session, sans remboursement, en cas de comportement inapproprié ou perturbant pour les autres participants.",
    ],
  },
  {
    num: "05",
    title: "Cuisson & créations",
    points: [
      "Après l'atelier, nous émaillons puis cuisons vos pièces dans notre four.",
      "Vos créations sont à récupérer sous 2 mois après notre message de disponibilité ; passé ce délai, nous pourrons être amenés à en disposer.",
      "La céramique a ses humeurs : malgré tout notre soin, de légères variations, fissures ou défauts peuvent exceptionnellement apparaître à la cuisson, sans que la responsabilité de l'atelier puisse être engagée.",
      "Les couleurs se transforment au four : aucun rendu esthétique précis ne peut être garanti à l'identique de l'aspect avant cuisson.",
      "Si vous reproduisez une œuvre existante, le respect des droits d'auteur reste de votre seule responsabilité ; l'atelier ne saurait être tenu responsable d'une reproduction d'œuvre protégée.",
    ],
  },
];

export default function Reglement() {
  useEffect(() => {
    document.title = "Règlement intérieur — Terre à Deux, café céramique à Auch";
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="reglement-page" className="min-h-screen bg-[#FBF8F3]">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-16 md:py-24">
        <a href="/" data-testid="reglement-back-link" className="inline-flex items-center gap-2 text-sm text-[#8A7971] hover:text-[#C85A32] transition-colors mb-10">
          <ArrowLeft size={15} /> Retour au site
        </a>

        <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#C85A32] mb-3">Terre à Deux — Café céramique, Auch</p>
        <h1 className="font-display tracking-tight text-[#201815] text-3xl sm:text-4xl lg:text-5xl mb-6">Le règlement de la maison</h1>
        <p className="text-sm text-[#5C4E48] leading-relaxed mb-12 max-w-xl">
          Quelques règles simples pour que chaque atelier reste un bon moment pour tout le monde. Merci de les lire avant votre venue.
        </p>

        <div className="space-y-6">
          {ARTICLES.map((a) => (
            <section key={a.num} data-testid={`reglement-article-${a.num}`} className={`relative overflow-hidden rounded-2xl border border-[#E5DCD3] p-7 md:p-9 ${parseInt(a.num) % 2 === 1 ? "bg-white" : "bg-[#F4EFEA]"}`}>
              <span className="absolute -top-3 -right-1 font-display italic text-7xl leading-none text-[#C85A32]/10 select-none">{a.num}</span>
              <h2 className="relative font-display text-2xl text-[#201815] mb-4">{a.title}</h2>
              <ul className="relative space-y-3">
                {a.points.map((p, i) => (
                  <li key={i} className="text-sm text-[#5C4E48] leading-relaxed flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#C85A32] shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <p className="mt-10 rounded-2xl bg-[#201815] text-[#FBF8F3] p-7 text-sm leading-relaxed">
          Participer à un atelier, c'est accepter ce règlement. Merci de votre confiance — et belle création !
        </p>
      </div>
    </div>
  );
}
